import { render, staticRenderFns } from "./select-cms-item-field.vue?vue&type=template&id=53e34bb0&scoped=true"
import script from "./select-cms-item-field.vue?vue&type=script&lang=js"
export * from "./select-cms-item-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e34bb0",
  null
  
)

export default component.exports